import { render, staticRenderFns } from "./in-preview-test-paper.vue?vue&type=template&id=faec93be"
import script from "./in-preview-test-paper.vue?vue&type=script&lang=js"
export * from "./in-preview-test-paper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports